<template>
  <Avatar v-bind="$attrs" :src="apiResourceUrl(src, apiOrigin)"><slot /></Avatar>
</template>

<script setup lang="ts">
import { Avatar } from 'ant-design-vue';
import { apiOrigin } from '@/api/client';
import { apiResourceUrl } from '@/utils/api-resource-url';

defineOptions({ inheritAttrs: false });
defineProps<{ src?: string | null }>();
</script>
